module.exports = __webpack_public_path__ + "static/Q8Answer_Gilbert_wishmastree-d1a713d67881a35bed8fa626ddf92fe1.jpg";